export default __webpack_public_path__ + "static/media/pin-cyan.5c601944.svg";